import { Routes, Route, Navigate } from "react-router-dom";
import { HomePage } from "../pages/HomePage";
import { ProductsPage } from "../pages/ProductsPage";
import { ProductDetailPage } from "../pages/ProductDetailPage";
import { SolutionsPage, SolutionDetailPage } from "../pages/SolutionsPage";
import { IndustriesPage, IndustryDetailPage } from "../pages/IndustriesPage";
import { PricingPage } from "../pages/PricingPage";
import { PricingEditionsPage } from "../pages/PricingEditionsPage";
import { DocsPage } from "../pages/DocsPage";
import { DocDetailPage } from "../pages/DocDetailPage";
import { SearchPage } from "../pages/SearchPage";
import { MarketplacePage } from "../pages/MarketplacePage";
import { MarketplaceDetailPage } from "../pages/MarketplaceDetailPage";
import { ConfigurePage } from "../pages/ConfigurePage";
import { ContactPage } from "../pages/ContactPage";
import { PreRegisterPage } from "../pages/PreRegisterPage";
import { TrialPage } from "../pages/TrialPage";
import { TrialHandoffPage } from "../pages/TrialHandoffPage";
import { TrialSuccessPage } from "../pages/TrialSuccessPage";
import { WhyItaasPage } from "../pages/WhyItaasPage";
import { PartnersPage } from "../pages/PartnersPage";
import {
  AffiliationLandingPage,
  AffiliateDashboardPage,
  AffiliateRegisterPage,
} from "../pages/AffiliationPage";
import { KnowledgePage } from "../pages/KnowledgePage";
import { AboutPage } from "../pages/AboutPage";
import { LegalPage } from "../pages/LegalPage";
import { PrivacyPage } from "../pages/PrivacyPage";
import { ComparePage } from "../pages/ComparePage";
import { AdminAffiliatesPage } from "../admin/AdminAffiliatesPage";
import { AdminAffiliateSettingsPage } from "../admin/AdminAffiliateSettingsPage";
import { AdminHandoffPage } from "../admin/AdminHandoffPage";
import { AdminLayout } from "../admin/AdminLayout";
import { AdminLoginPage } from "../admin/AdminLoginPage";
import { AdminLeadsPage } from "../admin/AdminLeadsPage";
import { AdminProductContentPage } from "../admin/AdminProductContentPage";
import { AdminSettingsPage } from "../admin/AdminSettingsPage";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/:slug" element={<ProductDetailPage />} />
      <Route path="/solutions" element={<SolutionsPage />} />
      <Route path="/solutions/:slug" element={<SolutionDetailPage />} />
      <Route path="/industries" element={<IndustriesPage />} />
      <Route path="/industries/:slug" element={<IndustryDetailPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/pricing/editions" element={<PricingEditionsPage />} />
      <Route path="/docs" element={<DocsPage />} />
      <Route path="/docs/:id" element={<DocDetailPage />} />
      <Route path="/knowledge" element={<KnowledgePage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/:slug" element={<MarketplaceDetailPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/preregister" element={<PreRegisterPage />} />
      <Route path="/configure" element={<ConfigurePage />} />
      <Route path="/trial" element={<TrialPage />} />
      <Route path="/trial/handoff" element={<TrialHandoffPage />} />
      <Route path="/trial/success" element={<TrialSuccessPage />} />
      <Route path="/why-itaas" element={<WhyItaasPage />} />
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/affiliation" element={<AffiliationLandingPage />} />
      <Route path="/affiliation/inscription" element={<AffiliateRegisterPage />} />
      <Route path="/affiliation/mon-lien" element={<AffiliateDashboardPage />} />
      <Route path="/compare" element={<ComparePage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/handoff" element={<AdminHandoffPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/leads" replace />} />
        <Route path="leads" element={<AdminLeadsPage />} />
        <Route path="affiliates" element={<AdminAffiliatesPage />} />
        <Route path="affiliation" element={<AdminAffiliateSettingsPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="product-content" element={<AdminProductContentPage />} />
      </Route>
    </Routes>
  );
}
